import type { JSX } from 'react'

export const NoContent = (): JSX.Element => (
  <use href='#noContent' height='100%' width='100%' />
)
